import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import KeyFeaturesOverview from "./sections/KeyFeaturesOverview";
import HowItWorks from "./sections/HowItWorks";
import MonetizationHighlights from "./sections/MonetizationHighlights";
import Testimonials from "./sections/Testimonials";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <KeyFeaturesOverview />
      <HowItWorks />
      <MonetizationHighlights />
      <Testimonials />
      <Footer />
    </div>;
}